import { render } from "./AddCommunity.vue?vue&type=template&id=436a8a46"
import script from "./AddCommunity.vue?vue&type=script&lang=js"
export * from "./AddCommunity.vue?vue&type=script&lang=js"

import "./AddCommunity.vue?vue&type=style&index=0&id=436a8a46&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__